(() => {
  const pendingClass = 'maxynn-currency-pending';
  const referenceSelector = [
    '[data-currency-reference]',
    '.totals__total-value',
    '.cart-item__final-price',
    '.price-item',
    '.free-shipping-progress__amount',
  ].join(', ');

  const normalizeScopes = (scopes) =>
    (Array.isArray(scopes) ? scopes : [scopes]).filter((scope) => scope instanceof Element);

  const getCurrencyToken = (text = '') => {
    if (/\b(?:AED|Dhs\.?)\b/i.test(text)) return 'AED';
    if (text.includes('€') || /\bEUR\b/i.test(text)) return 'EUR';
    if (text.includes('£') || /\bGBP\b/i.test(text)) return 'GBP';

    const currencyCode = text.match(/\b(?:USD|CAD|AUD|NZD)\b/i)?.[0];
    if (currencyCode) return currencyCode.toUpperCase();
    if (text.includes('$')) return 'DOLLAR';

    return null;
  };

  const findReference = (scopes) => {
    for (const scope of normalizeScopes(scopes)) {
      if (scope.matches(referenceSelector)) return scope;
      const reference = scope.querySelector(referenceSelector);
      if (reference) return reference;
    }
    return null;
  };

  const capture = (scopes) => {
    const reference = findReference(scopes);
    return { currencyToken: getCurrencyToken(reference?.textContent), hadReference: Boolean(reference) };
  };

  const hide = (scopes) => {
    normalizeScopes(scopes).forEach((scope) => scope.classList.add(pendingClass));
  };

  const reveal = (scopes) => {
    normalizeScopes(scopes).forEach((scope) => scope.classList.remove(pendingClass));
  };

  const convertAndReveal = (scopes, previousState = {}) => {
    const normalizedScopes = normalizeScopes(scopes);
    if (!normalizedScopes.length) return;

    let settled = false;
    let observer;
    let timeout;

    const finish = () => {
      if (settled) return;
      settled = true;
      observer?.disconnect();
      window.clearTimeout(timeout);
      reveal(normalizedScopes);
    };

    const hasExpectedCurrency = () => {
      const currentState = capture(normalizedScopes);
      if (!previousState.hadReference || !previousState.currencyToken) return true;
      return currentState.currencyToken === previousState.currencyToken;
    };

    observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => {
        if (hasExpectedCurrency()) finish();
      });
    });

    normalizedScopes.forEach((scope) =>
      observer.observe(scope, { childList: true, characterData: true, subtree: true })
    );

    window.bucksCC?.reConvert?.();

    window.requestAnimationFrame(() => {
      if (hasExpectedCurrency()) finish();
    });

    timeout = window.setTimeout(finish, 2500);
  };

  window.maxynnCurrencyBridge = { capture, convertAndReveal, hide, reveal };
})();
